import { useCurrentUser } from "@/queries/users";
import useActiveWorkspace from "./useActiveWorkspace";

const useIsWorkspaceAdmin = () => {
  const workspace = useActiveWorkspace();
  const currentUser = useCurrentUser();
  return currentUser.data?.memberships.workspaces.find(
    (w) => w.workspace_id === workspace?.id,
  )?.is_admin;
};

export { useIsWorkspaceAdmin };
